module.exports = __webpack_public_path__ + "static/media/l'imperatice.23614841.png";